import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import SubmittedList from "@/Components/common/client/timesheet/SubmittedList";
import TimesheetTypes from "@/Components/common/client/timesheet/TimesheetTypes";
import { updateactivePages } from "@/reducers/clientcommon";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import {
  deSelectAllCandidate,
  fetchSubmittedTimesheets,
  setSubmittedTimesheetsLoading,
  updateFilters,
  updatePagination,
} from "@/reducers/timesheets/timesheetsubmitted";
import useTitle from "@/utilities/hooks/useTitle";

const Submitted = () => {
  useTitle("Submitted Timesheets");
  const { pagination } = useSelector((state) => state.clientTimesheetSubmitted);
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setSubmittedTimesheetsLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchSubmittedTimesheets());
    dispatch(
      updateactivePages({
        activePage: "timesheets",
        activeSubPage: "submitted",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <TimesheetTypes />
      <SubmittedList />
    </div>
  );
};

export default Submitted;
